export default "__VITE_ASSET__KiR0AP1F__"